import qs from 'query-string';
import instance from 'api/instance';
import {
  IExportGeneralReportStatistics,
  IExportGeneralReports,
  IGetGeneralReportStatistics,
  IGetGeneralReports,
  IGetGeneralReportsForSchool,
  IGetGeneralReportsStatusHistory,
  IGetPracticalStatisticByVehicleType,
  IGetPracticalStatisticByVehicleTypeFile,
  IReportSchoolForGai,
} from './types';

export const getGeneralReports: IGetGeneralReports = (params) =>
  instance.get(
    `/general-reports/applications?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );

export const getGeneralReportsStatusHistory: IGetGeneralReportsStatusHistory = (
  params
) =>
  instance.get(
    `/general-reports/status-history?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );

export const exportGeneralReports: IExportGeneralReports = (params) =>
  instance.get(
    `general-reports/applications/export?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );

export const exportGeneralReportStatistics: IExportGeneralReportStatistics = (params) =>
  instance.get(
    `general-reports/statistic/export?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );

export const getGeneralReportStatistics: IGetGeneralReportStatistics = (params) =>
  instance.get(
    `general-reports/statistic?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );

export const exportGeneralReportStatusHistory: IExportGeneralReports = (
  params
) =>
  instance.get(
    `general-reports/status-history/export?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );

export const getGeneralReportsForSchool: IGetGeneralReportsForSchool = (
  params
) =>
  instance.get(
    `/general-reports/schools?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );

export const exportSchoolReports = (params: {
  startDate: string;
  endDate: string;
  search: string;
}) =>
  instance.get(
    `general-reports/schools/export?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );

export const getReportSchoolForGai: IReportSchoolForGai = (params) =>
  instance.get(
    `/general-reports/gai-schools?${qs.stringify(params, {
      skipEmptyString: true,
    })}`
  );


export const getPracticalStatisticByVehicleType: IGetPracticalStatisticByVehicleType = (params) => instance.get(`/general-reports/vehicle-type?${qs.stringify(params, {
  skipEmptyString: true,
})}`);

export const getPracticalStatisticByVehicleTypeFile: IGetPracticalStatisticByVehicleTypeFile = (params) =>
  instance.get(
    `/general-reports/vehicle-type/export?${qs.stringify(params, { skipEmptyString: true })}`
  );